export default defineNuxtRouteMiddleware(async (to) => {
  if (!useBelajarWajibStore().isAuthorized) {
    useBelajarWajibStore().clearTokens();
    return navigateTo({ path: "/pembelajaran-wajib/login" });
  }

  if (to.path.startsWith("/pembelajaran-mandiri")) {
    const isToggleMandiriAvailable = useToggleCheck("MANDIRI");
    if (isToggleMandiriAvailable) {
      return navigateTo("/login");
    }
  }
  if (to.path.startsWith("/pembelajaran-wajib/swajar")) {
    const courseType =
      localStorage.getItem("courseType") === "CPNS"
        ? "ORIENTASI_CPNS"
        : "SWAJAR";
    const isToggleSwajarAvailable = useToggleCheck(courseType);

    if (isToggleSwajarAvailable) {
      return navigateTo({
        path: "/maintenance",
        query: { page: courseType },
      });
    }
  }
});
